module.exports = __webpack_public_path__ + "static/media/apercu-light.fbc278f2.woff";